"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var lodash_1 = __importDefault(require("lodash"));
var Types_1 = require("DataStores/Account/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var PermissionGroup;
(function (PermissionGroup) {
    PermissionGroup["Block"] = "block";
    PermissionGroup["Content"] = "content";
})(PermissionGroup || (PermissionGroup = {}));
var StylePermissions = (function (_super) {
    __extends(StylePermissions, _super);
    function StylePermissions() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.toggleEditStyle = function (group) {
            var stylePermissionStore = _this.props.stylePermissionStore;
            var options = _this.accessOptions[group];
            var isCurrentlyEnabled = _this.isGroupEnabled(group);
            var ids = options.map(function (option) { return option.id; });
            if (isCurrentlyEnabled) {
                stylePermissionStore.disablePermissions(ids);
            }
            else {
                stylePermissionStore.enablePermissions(ids);
            }
        };
        _this.toggleAccessByKey = function (accessKey) {
            _this.props.stylePermissionStore.toggleAccess(accessKey);
        };
        return _this;
    }
    Object.defineProperty(StylePermissions.prototype, "accessOptions", {
        get: function () {
            var _a;
            var stylePermissionStore = this.props.stylePermissionStore;
            var mapValue = function (options) {
                return options.map(function (option) { return (__assign(__assign({}, option), { value: stylePermissionStore.isStyleAccessOn(option.id) })); });
            };
            var options = (_a = {},
                _a[PermissionGroup.Block] = mapValue(__spreadArray(__spreadArray([
                    {
                        id: Types_1.StyleAccessType.Block,
                        label: "access block style shortcuts",
                    },
                    {
                        id: Types_1.StyleAccessType.Text,
                        label: "access text style shortcuts",
                    },
                    {
                        id: Types_1.StyleAccessType.Motion,
                        label: "access animation style shortcuts",
                    }
                ], __read((this.props.stylePermissionStore.isAdvancedStyleEnabled
                    ? [{ id: Types_1.StyleAccessType.CSS, label: "access css style shortcuts" }]
                    : [])), false), [
                    {
                        id: Types_1.StyleAccessType.StyleLibrary,
                        label: "create and edit saved styles",
                    },
                    {
                        id: Types_1.StyleAccessType.BlockCustomColors,
                        label: "choose custom colors",
                    },
                ], false)),
                _a[PermissionGroup.Content] = mapValue(__spreadArray(__spreadArray([
                    {
                        id: Types_1.StyleAccessType.Toolbar,
                        label: "edit text styles",
                    },
                    {
                        id: Types_1.StyleAccessType.ToolbarTable,
                        label: "edit table styles",
                    },
                    {
                        id: Types_1.StyleAccessType.ToolbarQuote,
                        label: "edit quote styles",
                    },
                    {
                        id: Types_1.StyleAccessType.ToolbarAccept,
                        label: "edit accept button styles",
                    }
                ], __read((0, CommonUtils_1.includeIf)(this.props.usingFeature(FeatureFlag_1.default.Accordion), [
                    {
                        id: Types_1.StyleAccessType.Accordion,
                        label: "edit accordion styles",
                    },
                ])), false), [
                    {
                        id: Types_1.StyleAccessType.ContentCustomColors,
                        label: "choose custom colors",
                    },
                ], false)),
                _a);
            return options;
        },
        enumerable: false,
        configurable: true
    });
    StylePermissions.prototype.isGroupEnabled = function (group) {
        return lodash_1.default.some(this.accessOptions[group], "value");
    };
    StylePermissions.prototype.render = function () {
        var _this = this;
        var _a = this, _b = _a.props, stylePermissionStore = _b.stylePermissionStore, children = _b.children, explorePlans = _b.explorePlans, accessOptions = _a.accessOptions;
        var stylePermissionEnabled = stylePermissionStore.isStylePermissionEnabled;
        return (react_1.default.createElement("div", { className: "style-permissions" },
            react_1.default.createElement("div", { className: "style-permissions__controls" },
                react_1.default.createElement("div", { className: "style-permissions__description" }, "As an admin, you can change which styling controls your team can access"),
                [PermissionGroup.Block, PermissionGroup.Content].map(function (group) { return (react_1.default.createElement(kaleidoscope_1.ToggleGroup, { key: group, on: _this.isGroupEnabled(group), disabled: !stylePermissionStore.isStylePermissionEnabled, name: "Edit ".concat(group, " styles"), onGroupToggle: _this.toggleEditStyle.bind(_this, group), items: accessOptions[group], onItemToggle: _this.toggleAccessByKey })); })),
            react_1.default.createElement("div", { className: "style-permissions__view" },
                !stylePermissionEnabled && (react_1.default.createElement("div", { className: "style-permissions__disabled-overlay" },
                    react_1.default.createElement("div", { className: "style-permissions__disabled-overlay-content" },
                        react_1.default.createElement("div", { className: "style-permissions__disabled-overlay-description" },
                            react_1.default.createElement("div", { className: "style-permissions__disabled-overlay-title" }, "Upgrade to set team permissions"),
                            react_1.default.createElement("div", { className: "style-permissions__disabled-overlay-subtitle" }, "Need to change which styling controls your team has access to? Upgrade your plan to set")),
                        react_1.default.createElement("div", { onClick: explorePlans, className: "button button--is-idle button--primary button--medium button--normal-width center" }, "Explore plans")))),
                children)));
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], StylePermissions.prototype, "accessOptions", null);
    StylePermissions = __decorate([
        mobx_react_1.observer
    ], StylePermissions);
    return StylePermissions;
}(react_1.default.Component));
exports.default = StylePermissions;
